import { Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { Facet } from '@spartacus/core'
import { FacetListComponent, FacetService } from '@spartacus/storefront'

@Component({
  selector: 'mb-facet-list',
  templateUrl: './mb-facet-list.component.html',
  styleUrls: ['./mb-facet-list.component.scss'],
})
export class MbFacetListComponent extends FacetListComponent {

  @Input()
  facetsList: Facet[] | undefined

  constructor (protected facetService: FacetService,
              protected elementRef: ElementRef,
              protected renderer: Renderer2) {
    super(facetService, elementRef, renderer)
  }
}
